import React from 'react';

import { BaseIconProps } from '.';

export const Alert = ({ fill }: BaseIconProps) => {
  return (
    <>
      <g clipPath="url(#clip0)">
        <path
          d="M539.521 150.858L85.504 929.173C85.504 929.173 85.5041 929.173 85.5041 929.173H993.538L539.521 150.858ZM539.521 64.5259C568.478 64.5259 597.436 78.8031 614.093 107.358L1068.11 885.673C1101.68 943.226 1060.17 1015.5 993.538 1015.5H85.5041C18.8735 1015.5 -22.641 943.226 10.9322 885.673L464.949 107.358C481.606 78.8031 510.563 64.5259 539.521 64.5259Z"
          fill={fill}
        />
        <path
          d="M496.355 389.596V648.592H582.687V389.596H496.355Z"
          fill={fill}
        />
        <path
          d="M496.355 734.924V821.256H582.687V734.924H496.355Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="1080" height="1080" fill="white" />
        </clipPath>
      </defs>
    </>
  );
};
